import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { post } from "@/libs/http";
import { RummyRecommendReq, RummyRecommendRes } from "@/types/api/hall/rummy-recommend";


export const getRummyRecommend = ({ params }: { params: RummyRecommendReq; }) => post<RummyRecommendRes>('/hall/v1/rummy_recommend', params);

export const useRummyRecommend = createApiMutationHook(getRummyRecommend);